import React from 'react';
import update from 'react-addons-update';
import _ from 'underscore';
import formMixin from 'mixins/user-form-mixin';
import { withTranslation } from 'react-i18next';
import BillingStore from 'stores/shipper/BillingStore';
import SessionStore from 'stores/SessionStore';
import ROLES from 'constants/UserRoles';
import CargomaticCard from 'components/v2/card';
import { titleize } from 'underscore.string';
import AddressForm from './address-form';
import { updateStateForField } from './user-form-utils';
import Alert from '../../ui/Alert';
import { getClassName } from '../../../utils/ui/classes';

class BillingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.getStateFromProps(),
      validations: {},
      isDisabled: !this.checkPermissonForEditBillingAddress(),
    };
  }

  componentDidMount() {
    BillingStore.addChangeListener(this.updateValidation);
  }

  componentWillUnmount() {
    BillingStore.removeChangeListener(this.updateValidation);
  }

  checkPermissonForEditBillingAddress() {
    const logedInUser = SessionStore.getUser();
    /**
     * if user type is Shipper or Admin with role finance-admin or role shipper-onboarding.
     * He can edit billing address else not.
     */
    if (
      logedInUser._type === ROLES.SHIPPER ||
      logedInUser.roles.includes(ROLES.FINANCE_ADMIN) ||
      logedInUser.roles.includes(ROLES.SHIPPER_ONBOARDING)
    ) {
      return true;
    }
    return false;
  }

  updateValidation = () => {
    this.setState({
      validations: BillingStore.getBillingAddressValidation(),
    });
  };

  handleAddressChange = (updatedAddress) => {
    this.setState((prevState) => {
      return update(prevState, { $merge: updatedAddress });
    });
  };

  render() {
    const { t } = this.props;
    return (
      <CargomaticCard
        classname={getClassName(this.props.className)}
        header={() => <h3 className="my-0">{t('BILLING_ADDRESS')}</h3>}
        footer={() => (
          <div className="form-actions">
            <button
              className="button button-green"
              onClick={this.onUpdate}
              disabled={this.state.isDisabled}
            >
              {titleize(t('SAVE'))}
            </button>
          </div>
        )}
        grayFooter
      >
        {!_.isEmpty(this.state.validations) && (
          <Alert type="error">
            <ul>
              {_.values(this.state.validations).map((error) => (
                <li key={error}>{t(error)}</li>
              ))}
            </ul>
          </Alert>
        )}
        <div className="">
          <AddressForm
            address={this.state}
            disabled={this.state.isDisabled}
            onChange={(address) => this.handleAddressChange(address)}
          />
          <div className="mb-4">
            <label className="block mb-2 form-label">{t('EMAIL')}</label>
            <input
              value={this.state.email}
              className="block w-full mb-4 form-field"
              type="email"
              disabled={this.state.isDisabled}
              onChange={(e) => updateStateForField(e, 'email', this)}
            />
          </div>
        </div>
      </CargomaticCard>
    );
  }

  onUpdate = () => {
    if (this.props.onSave) {
      this.props.onSave(this.state);
    }
  };
}

export default withTranslation()(formMixin(BillingForm));
